module.exports = __webpack_public_path__ + "img/goods6_6.44178b91.jpg";